import { useCallback, useEffect, useState } from 'react';
import api from '../../services/api';
import { emitToast } from '../../context/toast';

/**
 * Banner sync Training ↔ FOOD — oculto en UX (Food = foodplan.tech).
 * Implementación legacy conservada abajo como `TrainingFoodSyncBannerLegacy` (no exportada).
 */
export default function TrainingFoodSyncBanner() {
  return null;
}

/** @deprecated Conservado; no montar en UI. */
export function TrainingFoodSyncBannerLegacy({ userId, compact = false }) {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const q = userId ? `?user_id=${userId}` : '';
      const r = await api.get(`/training/sync/food/status${q}`);
      setStatus(r.data?.data || null);
    } catch {
      setStatus(null);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => { load(); }, [load]);

  if (loading || !status?.both_paid) return null;

  const bridgeError = status.food?.bridge_error;
  const canImport = Boolean(status.can_import_from_food);
  const canExport = Boolean(status.can_export_to_food);
  if (!canImport && !canExport && !bridgeError) return null;

  const runSync = async (direction) => {
    setSyncing(true);
    try {
      const r = await api.post('/training/sync/food', { direction, user_id: userId });
      const d = r.data?.data || {};
      if (d.error) {
        emitToast(d.error, 'error');
      } else {
        emitToast(
          direction === 'food_to_training'
            ? `Importados: ${d.measuresImported ?? 0} medidas, ${d.photosImported ?? 0} fotos desde FOOD`
            : `Exportados ${d.exported ?? 0} medidas y ${d.photosExported ?? 0} fotos a FOOD`,
          'success',
        );
      }
      await load();
      window.dispatchEvent(new CustomEvent('d28d:progress:refresh'));
    } catch (e) {
      emitToast(e.response?.data?.error || 'Error sincronizando', 'error');
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div className={`rounded-xl border border-sky-200 bg-sky-50 p-4 mb-4 text-sm text-stone-800 space-y-2 ${compact ? 'p-3' : ''}`}>
      <p className="font-semibold">Una sola carga · Training ↔ FOOD</p>
      <p className="text-stone-600 text-xs">
        Con ambos módulos activos, importa o exporta para no subir fotos ni medidas dos veces.
        FOOD: {status.food?.measurements ?? 0} medidas · Training: {status.training?.measurements ?? 0} medidas.
      </p>
      {bridgeError ? (
        <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-lg p-2">
          Bridge FOOD: {bridgeError}. Revisa que foodplan-backend esté arriba.
        </p>
      ) : null}
      <div className="flex flex-wrap gap-2">
        {canImport ? (
          <button type="button" className="btn-secondary text-xs" disabled={syncing} onClick={() => runSync('food_to_training')}>
            Importar desde FOOD → Training
          </button>
        ) : null}
        {canExport ? (
          <button type="button" className="btn-secondary text-xs" disabled={syncing} onClick={() => runSync('training_to_food')}>
            Exportar Training → FOOD
          </button>
        ) : null}
      </div>
    </div>
  );
}
